export const formatCurrencyFull = (
  value,
  {
    decimals = 2,
    prefix = "$",
    suffix = "",
    locale = undefined
  } = {}
) => {
  const numeric = Number(value);
  if (!isFinite(numeric)) return "";
  const formatted = numeric.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
  return `${prefix}${formatted}${suffix}`;
};

const trimTrailingZero = (value) => {
  return value.replace(/\.0$/, "");
};

const formatCompactValue = (absValue, unit, decimals, locale) => {
  const divisor = unit === "M" ? 1000000 : 1000;
  const raw = absValue / divisor;
  const rounded = Number(raw.toFixed(decimals));
  const formatted = rounded.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
  return trimTrailingZero(formatted) + unit;
};

export const formatCurrencyCompact = (
  value,
  {
    decimals = 2,
    compactDecimals = 1,
    kThreshold = 100000,
    mThreshold = 1000000,
    prefix = "$",
    suffix = "",
    locale = undefined
  } = {}
) => {
  const numeric = Number(value);
  if (!isFinite(numeric)) return "";
  const sign = numeric < 0 ? "-" : "";
  const absValue = Math.abs(numeric);

  if (absValue >= mThreshold) {
    const compact = formatCompactValue(absValue, "M", compactDecimals, locale);
    return `${sign}${prefix}${compact}${suffix}`;
  }

  if (absValue >= kThreshold) {
    const roundedK = Number((absValue / 1000).toFixed(compactDecimals));
    if (roundedK >= 1000) {
      const compact = formatCompactValue(absValue, "M", compactDecimals, locale);
      return `${sign}${prefix}${compact}${suffix}`;
    }
    const compact = formatCompactValue(absValue, "k", compactDecimals, locale);
    return `${sign}${prefix}${compact}${suffix}`;
  }

  const formatted = absValue.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
  return `${sign}${prefix}${formatted}${suffix}`;
};

export const formatCurrencyAdaptive = (value, options = {}) => {
  const numeric = Number(value);
  const decimals = Number.isInteger(numeric) ? 0 : (options.decimals ?? 2);
  return formatCurrencyCompact(value, { ...options, decimals });
};
